import type { ProjectSettings } from '$lib/model/types';

export function lpiCeiling(settings: ProjectSettings): number {
  return Math.max(
    1,
    Math.floor(Math.min(settings.dpi / 2, settings.mesh_count / 3.5)),
  );
}

export function pixelDimensions(settings: ProjectSettings): {
  width: number;
  height: number;
} {
  const inPerUnit =
    settings.units === 'in'
      ? 1
      : settings.units === 'cm'
        ? 1 / 2.54
        : 1 / 25.4;
  return {
    width: Math.max(
      1,
      Math.round(settings.target_width * inPerUnit * settings.dpi),
    ),
    height: Math.max(
      1,
      Math.round(settings.target_height * inPerUnit * settings.dpi),
    ),
  };
}

export const DPI_PRESETS = [150, 300, 600, 1200];
export const MESH_PRESETS = [110, 156, 200, 230, 305];
